<template>
  <div class="panel panel-default">
    <div class="panel-body">
      <form v-if="!done" method="POST" :action="bookingUrl" @submit.prevent="submitBooking"
            class="js-form-step form-step"
            :class="{'is-loading': travelLoading}">

        <input tabindex="-1" type="hidden" name="_token" :value="csrfToken">
        <loader-box v-if="pathLoading"/>
        <loader-box v-if="travelLoading"/>
        <loader-box v-if="userLoading"/>
        <input tabindex="-1" type="hidden" name="client_id" id="client_id" v-model="booking.client_id">
        <div class="js-form-step-tab form-step-tab">
          <div class="form-group">
            <label for="path_id">Trajet</label>
            <select name="path_id" id="path_id" :data-value="booking.path_id" class="form-control select2"
                    v-model="booking.path_id">
              <option value="0">--- Sélectionner trajet ---</option>
              <option v-for="path in paths" :value="path.id">{{ path.name }}</option>
            </select>
          </div>
          <div class="row">
            <div class="col-sm-6">
              <div class="form-group">
                <label for="travel_id">Voyage</label>
                <select name="travel_id" id="travel_id" :data-value="booking.travel_id" class="form-control select2"
                        v-model="booking.travel_id">
                  <option value="0">--- Sélectionner voyage ---</option>
                  <option v-for="travel in travels" :value="travel.id">{{ travel.name }}</option>
                </select>
              </div>
            </div>
            <div class="col-sm-6">
              <div class="form-group">
                <label for="at" class="control-label">Date</label>
                <input tabindex="-1" type="text" name="at" id="at" disabled="disabled" class="form-control"
                       v-model="currentTravel.at_formatted">
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-sm-6">
              <div class="form-group">
                <label for="departure_id" class="control-label">Départ</label>
                <select name="departure_id" id="departure_id" class="form-control select2"
                        v-model="booking.departure_id">
                  <option value="0">-- Sélectionner point de départ --</option>
                  <option :value="place.id" v-for="place in filteredDeparture">{{ place.name }}</option>
                </select>
              </div>
            </div>
            <div class="col-sm-6">
              <div class="form-group">
                <label for="arrival_id" class="control-label">Arrivée</label>
                <select name="arrival_id" id="arrival_id" class="form-control"
                        v-model="booking.arrival_id">
                  <option value="0">-- Sélectionner point de d'arrivée --</option>
                  <option :value="place.id" v-for="place in filteredArrivals">{{ place.name }}</option>
                </select>
              </div>
            </div>
          </div>
        </div>
        <div class="js-form-step-tab form-step-tab">
          <div class="blur-overlay" v-if="isForSelf" style="background-color: rgba(0,0,0, .2)"></div>
          <div class="row">
            <div class="col-sm-12">
              <div class="form-group">
                <label for="phone_number" class="control-label">Numéro téléphone</label>
                <input tabindex="-1" type="text" name="phone_number" id="phone_number" autocomplete="off"
                       class="form-control"
                       v-model="booking.phone_number">
              </div>
            </div>
            <div class="col-sm-6">
              <div class="form-group" :class="{'is-loading': userLoading}">
                <label class="form-label">Civilité</label>
                <select class="form-control" name="title" v-model="booking.title" id="title">
                  <option :value="title" v-for="title in userTitles">{{ title }}</option>
                </select>
              </div>
            </div>
            <div class="col-sm-6">
              <div class="form-group" :class="{'is-loading': userLoading}">
                <label for="email" class="control-label">Email</label>
                <input tabindex="-1" type="text" name="email" id="email" class="form-control" placeholder="(optionnel)"
                       v-model="booking.email">
              </div>
            </div>
            <div class="col-sm-6">
              <div class="form-group" :class="{'is-loading': userLoading}">
                <label for="first_name" class="control-label">Prénom</label>
                <input tabindex="-1" type="text" name="first_name" id="first_name" class="form-control"
                       v-model="booking.first_name">
              </div>
            </div>
            <div class="col-sm-6">
              <div class="form-group" :class="{'is-loading': userLoading}">
                <label for="last_name" class="control-label">Nom</label>
                <input tabindex="-1" type="text" name="last_name" id="last_name" class="form-control"
                       v-model="booking.last_name">
              </div>
            </div>
          </div>
        </div>
        <div class="js-form-step-tab form-step-tab">
          <div class="form-group" v-if="!booking.is_paid">
            <label for="code">Code promo</label>
            <input type="text" name="code" id="code" v-model="booking.code" class="form-control"/>
          </div>
          <button class="app-button-inverted btn-block" type="submit">Sauvegarder <i class="fa fa-save"></i></button>
        </div>
        <div class="form-step-indicators js-form-step-indicators"></div>
        <div class="alert in" v-for="message in messages" :class="'alert-' + message.type"
             v-show="message.content && message.content.length > 0">
          <small>{{ message.content }}</small>
        </div>
        <div class="form-step-navigation">
          <button type="button" class="form-step-previous js-form-step-previous is-disabled"><i
            class="fa fa-arrow-left"></i> Précedent
          </button>
          <button type="button" class="form-step-next js-form-step-next">Suivant <i class="fa fa-arrow-right"></i>
          </button>
        </div>
        <div style="margin-top: 10px;" class="alert alert-warning in" v-show="booking.full_name.length > 0">
          Vous ne réservez pas pour {{ booking.full_name }} ? <strong><a href="#clear-field"
                                                                         @click.prevent="clearFields"> cliquer
          ici</a></strong>
        </div>
      </form>

      <div class="alert alert-info" v-if="done && booking.later">
        <a href="#" @click.prevent="resetForm">Faire une autre réservation</a>
      </div>
    </div>
  </div>
</template>

<script>
  import debounce from 'lodash.debounce'
  import FormStep from '../../form-step'
  import AppApiResponse from '../../AppApiResponse'
  import {handleErrors, resetErrors} from '../../form'
  import LoaderBox from '../Loader/LoaderBox'
  import appAxios from '../../app-axios.js'
  import Swal from 'sweetalert2'

  export default {
    name: 'booking-create',
    components: {
      LoaderBox
    },
    props: {
      promoCode: {type: String},
      bookingForUserTravelUrl: {type: String},
      pathUrl: {type: String},
      bookingUrl: {type: String},
      bookingShowUrl: {type: String},
      bookingConfirmUrl: {type: String},
      pathTravelUrl: {type: String},
      travelShowUrl: {type: String},
      userUrl: {type: String},
      travelId: {type: Number, default: 0},
      clientId: {type: Number, default: 0},
      csrfToken: {type: String},
      userQueryUrl: {type: String},
      departureId: {type: Number},
      arrivalId: {type: Number},
    },
    data () {
      return {
        isForSelf: false,
        isAdmin: false,
        userTitles: ['Monsieur', 'Madame'],
        formStep: null,
        done: false,
        cancelMessage: '',
        messages: [],
        type: 'danger',
        pathLoading: false,
        userLoading: false,
        travelLoading: false,
        booking: {
          departure_id: 0,
          arrival_id: 0,
          path_id: 0,
          code: '',
          later: 0,
          title: '',
          full_name: '',
          travel: {
            sit_left: 0,
            places: []
          },
          travel_id: 0,
          client_id: 0
        },
        travels: [],
        paths: [],
        currentPath: 0,
        currentTravel: {
          at: '',
          places: []
        },
        $formStep: null,
        $travelSelect: null,
        $pathSelect: null,
        fieldNames: []
      }
    },
    computed: {
      filteredDeparture () {
        return this.currentTravel.places
      },
      filteredArrivals () {
        if (!this.bookingDeparture) {
          return this.currentTravel.places
        }
        return this.currentTravel.places.filter(place => {
          return Math.abs(this.bookingDeparture.order - place.order) >= 30
        })
        // TODO: not working
        // if (!this.bookingDeparture) {
        //   return this.currentTravel.places
        // }
        // return this.currentTravel.places.filter(place => {
        //   if (this.isSameDirection(this.booking.travel, this.bookingDeparture, place)) {
        //     return place.order > this.bookingDeparture.order
        //   } else {
        //     return place.order < this.bookingDeparture.order
        //   }
        // })
      },
      bookingDeparture () {
        return this.booking.travel.places.find(place => place.id === this.booking.departure_id)
      },
      bookingArrival () {
        return this.booking.travel.places.find(place => place.id === this.booking.arrival_id)
      }
    },
    methods: {
      resetForm () {
        // not working so refreshing
        window.location.reload()
        // this.done = false
        // this.booking = Object.assign({}, this.booking, {
        //   path_id: 0,
        //     code: '',
        //     later: false,
        //     full_name: '',
        //     travel: {
        //     places: []
        //   },
        //   travel_id: 0,
        //     departure_id: 0,
        //     arrival_id: 0,
        //     client_id: 0
        // })
      },
      isSameDirection (travel, departure, arrival) {
        let travelDirection = travel.departure.order - travel.arrival.order > 0
        let bookingDirection = departure.order - arrival.order > 0
        return travelDirection === bookingDirection
      },
      checkUserDidNotBookFor (user_id, travel_id) {
        return new Promise((resolve, reject) => {
          appAxios(this.bookingForUserTravelUrl.replace(':user', user_id).replace(':travel', travel_id))
            .then(apiResponse => {
              if (apiResponse.isSuccess()) {
                resolve(apiResponse)
              } else {
                reject(apiResponse)
              }
            })
            .catch(apiResponse => reject(apiResponse))
        })
      },
      onTravelChange (e) {
        let travel_id = e.target.value
        if (!travel_id) {
          return
        }
        this.messages = []
        this.formStep.enableButtonNext()
        this.loadTravel(travel_id)
          .then(apiResponse => {
            if (this.booking.client_id) {
              this.checkUserDidNotBookFor(this.booking.client_id, travel_id)
                .then(apiResponse => {
                  console.log(apiResponse)
                })
                .catch(apiResponse => {
                  console.log(apiResponse)
                  this.addMessage(apiResponse.getMessage(), 'danger', -1)
                  if (!this.isAdmin) {
                    this.formStep.disableButtonNext()
                  }
                })
            }
          })
      },
      loadTravel (travel_id) {
        return new Promise((resolve, reject) => {
          this.travelLoading = true
          appAxios(this.travelShowUrl.replace(':travel', travel_id))
            .then((apiResponse) => {
              this.booking.travel = this.currentTravel = apiResponse.getData()
              this.booking.path_id = this.booking.travel.path_id
              this.booking.travel_id = this.booking.travel.id
              if (this.booking.travel.sit_left > 0) {
                this.addMessage('Places restantes: ' + this.booking.travel.sit_left, 'info')
              } else {
                this.addMessage('Plus de place restante pour ce voyage!', 'danger')
                this.formStep.disableButtonNext()
              }
              resolve(apiResponse)
            })
            .catch((apiResponse) => {
              reject(apiResponse)
            })
            .then(_ => this.travelLoading = false)
        })
      },
      clearFields () {
        this.booking.first_name = ''
        this.booking.last_name = ''
        this.booking.full_name = ''
        this.booking.email = ''
        this.booking.client_id = ''
        this.booking.title = ''
        this.booking.phone_number = ''
        this.formStep.enableButtonNext()
        this.isForSelf = false
      },
      setFields (user) {
        this.booking.first_name = user.first_name
        this.booking.last_name = user.last_name
        this.booking.full_name = user.first_name + ' ' + user.last_name
        this.booking.email = user.email
        this.booking.client_id = user.id
        this.booking.title = user.title
        this.booking.phone_number = user.phone_number
      },
      onPhoneNumberKeyUp (value) {
        if (!value || value.length < 2) {
          return
        }
        this.userLoading = true
        appAxios({
          url: this.userQueryUrl.replace(':query', value),
          method: 'GET',
          // headers: {
          //   'Authorization': 'Bearer ' + this.apiToken
          // }
        })
          .then((response) => {
            let apiResponse = new AppApiResponse(response)
            if (apiResponse.isSuccess()) {
              let users = apiResponse.getData()
              if (users.length > 0) {
                let user = users[0]
                this.setFields(user)
                // } else {
                //   this.clearFields()
              }
            } else {
              debugger
              console.error(apiResponse)
            }
          })
          .catch((error) => {
            let apiResponse = new AppApiResponse(error)
            debugger
            console.error(apiResponse)
          })
          .then(_ => this.userLoading = false)
      },
      loadPaths () {
        return new Promise((resolve, reject) => {
          this.pathLoading = true
          appAxios.get(this.pathUrl)
            .then((apiResponse) => {
              this.paths = apiResponse.getData()
              resolve(apiResponse)
            })
            .catch(apiResponse => {
              console.error(apiResponse)
              debugger
              reject(apiResponse)
            })
            .then(_ => this.pathLoading = false)
        })

      },
      addMessage (content, type = null, time = 5000) {
        let message = {
          content, type, time,
        }
        this.messages.push(message)
        if (type) {
          this.type = type
        }
        // disabled for now
        // if (time !== -1) {
        //   setTimeout(() => {
        //     let index = this.messages.findIndex(msg => msg.content === message.content)
        //     this.messages.splice(index, 1)
        //   }, time)
        // }
      },
      loadTravels (path_id) {
        this.currentTravel.at = ''
        this.travelLoading = true
        this.messages = []
        this.formStep.enableButtonNext()
        appAxios.get(this.pathTravelUrl.replace(':path', path_id))
          .then((response) => {
            let apiResponse = new AppApiResponse(response)
            if (apiResponse.isSuccess()) {
              this.travels = apiResponse.getData()
              if (this.travels.length <= 0) {
                this.addMessage('Aucune voyage de prévu pour ce trajet!', 'danger', 5000)
                this.formStep.disableButtonNext()
              }
            } else {
              debugger
              console.error(apiResponse)
            }
          })
          .catch((error) => {
            let apiResponse = new AppApiResponse(error)
            debugger
            console.error(apiResponse)
          })
          .then(_ => this.travelLoading = false)
      },
      submitBooking (later) {
        this.messages = []
        resetErrors(this.fieldNames, {
          classList: ['has-error', 'has-success']
        })
        this.travelLoading = true
        console.log({booking: this.booking})
        appAxios.put(this.bookingUrl, this.booking)
          .then(apiResponse => {
            this.done = true
            let booking = apiResponse.getData()
            window.location = this.bookingShowUrl.replace(':booking', booking.id)
          })
          .catch(apiResponse => {
            this.processErrors(apiResponse)
          })
          .then(_ => this.travelLoading = false)
      },
      processErrors (apiResponse) {
        this.errors = apiResponse.getData()
        this.addMessage(apiResponse.getMessage(), 'danger')
        handleErrors(this.errors, this.fieldNames, {
          feedbackClass: 'help-block',
          errorClass: 'has-error'
        })
        setTimeout(() => {
          resetErrors(this.fieldNames, {
            classList: ['has-error', 'has-success']
          })
        }, 10000)
      },
      loadUser () {
        if (!this.clientId) {
          return
        }
        this.userLoading = true
        appAxios({
          url: this.userUrl.replace(':user', this.clientId)
        })
          .then(response => {
            let apiResponse = new AppApiResponse(response)
            if (apiResponse.isSuccess()) {
              let user = apiResponse.getData()
              this.setFields(user)
              this.booking.phone_number = user.phone_number
              if (user.is_admin) {
                this.isAdmin = true
                this.booking.client_id = 0
                let $phoneInput = this.$el.querySelector('#phone_number')
                $phoneInput.addEventListener('keyup', debounce(e => {
                  this.onPhoneNumberKeyUp(e.target.value)
                }, 1500))
                // considering that admin is always booking for other
                // so no setField
              } else {
                this.isForSelf = true
              }
            } else {
              this.clearFields()
              console.error(apiResponse)
              debugger
            }
          })
          .catch(error => {
            this.clearFields()
            let apiResponse = new AppApiResponse(error)
            console.error(apiResponse)
            debugger
          })
          .then(_ => this.userLoading = false)
      }
    },
    mounted () {
      this.booking.client_id = this.clientId
      this.booking.code = this.code
      this.$formStep = this.$el.querySelector('.js-form-step')
      this.formStep = new FormStep(this.$formStep)
      this.$pathSelect = this.$el.querySelector('#path_id')
      this.$pathSelect.addEventListener('change', (e) => {
        this.loadTravels(e.target.value)
      })
      this.$travelSelect = this.$el.querySelector('#travel_id')
      this.$travelSelect.addEventListener('change', (e) => {
        this.onTravelChange(e)
      })
      this.loadPaths()
        .then(apiResponse => {
          if (this.travelId) {
            this.loadTravel(this.travelId)
              .then(apiResponse => {
                let travel = apiResponse.getData()
                this.booking.travel_id = travel.id
                this.booking.path_id = travel.path_id
                this.booking.departure_id = this.departureId
                this.booking.arrival_id = this.arrivalId
                this.booking.code = this.promoCode
                this.loadTravels(travel.path_id)
              })
          }
        })
      this.loadUser()

      this.fieldNames = Array.from(this.$formStep.elements).filter(item => {
        return item.name.length > 0 && item.name !== '_token'
      }).map(item => item.name)
    }
  }
</script>
<style>
  #pay-now-button, #pay-later-button {
    margin-top: 0;
  }
</style>



// WEBPACK FOOTER //
// resources/assets/js/component/Booking/BookingEdit.vue